<template>
  <div class="authenticationBox authenticationInfo">
    <van-cell-group>
      <van-cell :title="$t.authenticationInfo.authState" :value="shopText" />
      <van-cell
        v-if="FailureReason"
        :title="$t.authenticationInfo.reason"
        :value="FailureReason"
      />
    </van-cell-group>

    <div class="passportMain">
      <div class="passportBox">
        <h3 class="passportTitle">{{ $t.authenticationInfo.title }}</h3>
        <div v-if="!isEdit" class="preview-container1" @click="imagePreview"></div>
        <div v-if="!isEdit" class="preview-container2" @click="imagePreview"></div>
        <div class="passportImgBox">
          <van-uploader :after-read="afterRead1" :disabled="isEdit ? false : true">
            <van-image
              class="logoIcon"
              :src="
                authenticationInfo.passPortPhoto &&
                imgUrlFilter(authenticationInfo.passPortPhoto)
              "
            >
              <template v-slot:error>
                <img class="ImgIcon" src="~assets/img/auth/passPort.jpg" />
              </template>
            </van-image>
          </van-uploader>
        </div>
        <div class="passportImgBox">
          <van-uploader :after-read="afterRead2" :disabled="isEdit ? false : true">
            <van-image
              class="logoIcon"
              :src="
                authenticationInfo.passPortPhoto2 &&
                imgUrlFilter(authenticationInfo.passPortPhoto2)
              "
            >
              <template v-slot:error>
                <img class="ImgIcon" src="~assets/img/auth/driverLicence.jpg" />
              </template>
            </van-image>
          </van-uploader>
        </div>
      </div>
      <!-- 表单信息 -->
      <div class="inputBox">
        <label class="inputTitle">{{ $t.authenticationInfo.passPort }}</label>
        <input
          class="inputInfo"
          v-model="authenticationInfo.passPort"
          type="text"
          :disabled="!isEdit"
          :placeholder="$t.authenticationInfo.inputPassPort"
        />
      </div>
      <div class="inputBox">
        <label class="inputTitle">{{ $t.authenticationInfo.yourName }}</label>
        <input
          class="inputInfo"
          v-model="authenticationInfo.trueName"
          type="text"
          :disabled="!isEdit"
          :placeholder="$t.authenticationInfo.yourNamePlc"
        />
      </div>
      <div class="inputBox">
        <label class="inputTitle">{{ $t.authenticationInfo.bankName }}</label>
        <input
          class="inputInfo"
          v-model="authenticationInfo.bankName"
          type="text"
          :disabled="!isEdit"
          :placeholder="$t.authenticationInfo.bankNamePlc"
        />
      </div>
      <div class="inputBox">
        <label class="inputTitle">{{ $t.authenticationInfo.bankAccount }}</label>
        <input
          class="inputInfo"
          v-model="authenticationInfo.bankNumber"
          type="text"
          :disabled="!isEdit"
          :placeholder="$t.authenticationInfo.bankAccountPlc"
        />
      </div>
      <div class="inputBox">
        <label class="inputTitle">{{ $t.authenticationInfo.iBankNo }}</label>
        <input
          class="inputInfo"
          v-model="authenticationInfo.iBankNo"
          type="text"
          :disabled="!isEdit"
          :placeholder="$t.authenticationInfo.iBankNoPlc"
        />
      </div>
      <div class="inputBox">
        <label class="inputTitle">{{ $t.authenticationInfo.swiftCode }}</label>
        <input
          class="inputInfo"
          v-model="authenticationInfo.swiftCode"
          type="text"
          :disabled="!isEdit"
          :placeholder="$t.authenticationInfo.swiftCodePlc"
        />
      </div>
      <div class="inputBox">
        <label class="inputTitle">{{ $t.authenticationInfo.bankAddress }}</label>
        <input
          class="inputInfo"
          v-model="authenticationInfo.bankAddress"
          type="text"
          :disabled="!isEdit"
          :placeholder="$t.authenticationInfo.bankAddressPlc"
        />
      </div>
      <div class="inputBox">
        <label class="inputTitle">{{ $t.authenticationInfo.yourPostAdd }}</label>
        <input
          class="inputInfo"
          v-model="authenticationInfo.postAddress"
          type="text"
          :disabled="!isEdit"
          :placeholder="$t.authenticationInfo.yourPostAddPlc"
        />
      </div>
      <div class="inputBox" v-if="isEditShopName">
        <label class="inputTitle">{{ $t.authenticationInfo.shopName }}</label>
        <input
          class="inputInfo"
          v-model="authenticationInfo.shopName"
          type="text"
          :disabled="!isEdit"
          :placeholder="$t.authenticationInfo.yourShopName"
        />
      </div>
    </div>
    <div class="footerBox" v-if="isEdit">
      <div class="sub" @click="Submit">{{ $t.meta.submit }}</div>
    </div>

    <div class="footerBox" v-if="shopAuth.IsShopSubmit == 1 && shopAuth.IsShopCheck == 1">
      <div class="sub" @click="openShop">{{ $t.meta.openShop }}</div>
    </div>
  </div>
</template>
<script>
import Schema from "async-validator";
import Vue from "vue";
import { Image, Uploader, Dialog, Cell, CellGroup } from "vant";
import { isAPP, getPlatform } from "@/plugins/environment/type.js";

Vue.use(Uploader).use(Image).use(Cell).use(CellGroup);

export default {
  name: "Authentication",
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      fileList: [],
      shopAuth: {},
      shopText: "",
      FailureReason: "",
      isEdit: false,
      isEditShopName: false,
      authenticationInfo: {
        passPortPhoto: "", // 图片1
        passPortPhoto2: "", //图片2
        passPort: "", //护照号
        trueName: "", // 姓名
        bankName: "", // 银行名称
        bankNumber: "", // 银行卡号
        iBankNo: "", //
        swiftCode: "", //
        bankAddress: "", // 银行地址
        postAddress: "", // 邮寄地址
        shopName: "", //店铺名字
        ShopId: "",
      },
      photoIndex: 1,
    };
  },
  mounted() {
    let shopAuth = JSON.parse(localStorage.getItem("shopAuth"));
    this.shopAuth = shopAuth;
    if (
      (this.shopAuth.IsShopSubmit == 1 && this.shopAuth.IsShopCheck == -1) ||
      (this.shopAuth.IsShopCheck == 0 && this.shopAuth.IsShopSubmit == 0)
    ) {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }
    this.getLoadShopCheckInfo();
  },
  created() {
    let shopAuth = JSON.parse(localStorage.getItem("shopAuth"));
    this.shopAuth = shopAuth;
    if (this.shopAuth.IsShopSubmit == 1 && this.shopAuth.IsShopCheck == 1) {
      this.shopText = this.$t.authenticationInfo.haveAuth;
    }
    if (this.shopAuth.IsShopSubmit == 1 && this.shopAuth.IsShopCheck == -1) {
      this.isEditShopName = true;
      this.shopText = this.$t.authenticationInfo.reAuth;
    }
    if (this.shopAuth.IsShopCheck == 0 && this.shopAuth.IsShopSubmit == 0) {
      this.isEditShopName = true;
      this.shopText = this.$t.authenticationInfo.unAuth;
    }
    if (this.shopAuth.IsShopCheck == 0 && this.shopAuth.IsShopSubmit == 1) {
      this.shopText = this.$t.authenticationInfo.onAuth;
    }
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value.split("|")[0]);
    },
    getLoadShopCheckInfo() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.showLoading);
      this.$api.shop
        .loadShopCheckInfo()
        .then((res) => {
          const data = res.data;
          this.FailureReason = data.FailureReason;
          this.authenticationInfo.passPortPhoto = data.PassPortPhoto
            ? data.PassPortPhoto
            : "";
          this.authenticationInfo.passPortPhoto2 = data.PassPortPhoto2
            ? data.PassPortPhoto2
            : "";
          this.authenticationInfo.passPort = data.PassPort;
          this.authenticationInfo.trueName = data.TrueName;
          this.authenticationInfo.bankName = data.BankName;
          this.authenticationInfo.bankNumber = data.BankNumber;
          this.authenticationInfo.iBankNo = data.IBankNo;
          this.authenticationInfo.swiftCode = data.SwiftCode;
          this.authenticationInfo.bankAddress = data.BankAddress;
          this.authenticationInfo.postAddress = data.PostAddress;
          this.authenticationInfo.shopName = data.ShopName;
          this.authenticationInfo.ShopId = data.ShopId;
          this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
    Submit() {
      const rule = {
        trueName: {
          required: true,
          message: this.$t.authenticationInfo.yourNamePlc,
        },
        bankName: {
          required: true,
          message: this.$t.authenticationInfo.bankNamePlc,
        },
        bankNumber: [
          {
            required: true,
            message: this.$t.authenticationInfo.bankAccountPlc,
          },
        ],
        iBankNo: {
          required: true,
          message: this.$t.authenticationInfo.iBankNoPlc,
        },
        swiftCode: {
          required: true,
          message: this.$t.authenticationInfo.swiftCodePlc,
        },
        bankAddress: {
          required: true,
          message: this.$t.authenticationInfo.bankAddressPlc,
        },
        postAddress: {
          required: true,
          message: this.$t.authenticationInfo.yourPostAddPlc,
        },
        shopName: {
          required: true,
          message: this.$t.authenticationInfo.yourShopName,
        },
      };
      if (
        this.authenticationInfo.passPortPhoto ||
        this.authenticationInfo.passPortPhoto2
      ) {
        const validator = new Schema(rule);
        validator
          .validate(this.authenticationInfo)
          .then((_) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showLoading);
            let param = {
              PassPortPhoto: this.authenticationInfo.passPortPhoto,
              PassPortPhoto2: this.authenticationInfo.passPortPhoto2,
              PassPort: this.authenticationInfo.passPort,
              TrueName: this.authenticationInfo.trueName,
              BankName: this.authenticationInfo.bankName,
              BankNumber: this.authenticationInfo.bankNumber,
              IBankNo: this.authenticationInfo.iBankNo,
              SwiftCode: this.authenticationInfo.swiftCode,
              BankAddress: this.authenticationInfo.bankAddress,
              PostAddress: this.authenticationInfo.postAddress,
              ShopName: this.authenticationInfo.shopName,
            };
            return this.$api.userB.registerShopCheckInfo(param);
          })
          .then((res) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
            Dialog.confirm({
              message: "success",
              className: "showDialogClass",
            })
              .then(() => {
                this.$commonEnv.commonAction(this.$commonEnv.actionType.pop, {});
              })
              .catch(() => {
                this.$commonEnv.commonAction(this.$commonEnv.actionType.pop, {});
              });
          })
          .catch((err) => {
            if (err.errors) {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
                titleMsg: err.errors[0].message,
                type: "danger",
              });
            } else {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
                type: "danger",
                titleMsg: err.message,
              });
            }
          });
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.authenticationInfo.title,
          type: "danger",
        });
      }
    },
    imagePreview() {
      if (!this.isEdit) {
        var images = [];
        if (this.authenticationInfo.passPortPhoto) {
          images.push(this.authenticationInfo.passPortPhoto);
        }
        if (this.authenticationInfo.passPortPhoto2) {
          images.push(this.authenticationInfo.passPortPhoto2);
        }
        this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
          pictureList: images,
        });
      }
    },
    afterRead1(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      this.$commonMethod.showLoading();
      this.$api.userB
        .uploadImgFile(formData)
        .then((res) => {
          this.authenticationInfo.passPortPhoto = res.data.DefaultUrl;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
    afterRead2(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      this.$commonMethod.showLoading();
      this.$api.userB
        .uploadImgFile(formData)
        .then((res) => {
          this.authenticationInfo.passPortPhoto2 = res.data.DefaultUrl;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
    openShop() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "store",
        name: "store",
        query: [
          {
            name: "ShopId",
            value: this.authenticationInfo.ShopId,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
@mixin fontCommon {
  font-size: 1rem;
  color: #777777;
  font-family: Helvetica;
  font-weight: bold;
}
.van-cell-group {
  margin-top: 10px;
}
.infoLabel {
  font-size: 1.5rem;
  color: #01aaa3;
}
.authenticationBox {
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: inline-block;
  .passportBox {
    box-sizing: border-box;
    border-bottom: 0.1rem solid #ececec;
    padding-top: 10px;
    padding-bottom: 10px;
    ::v-deep .van-uploader {
      width: 100%;
    }
    ::v-deep .van-uploader__wrapper {
      justify-content: center;
    }
    ::v-deep .van-uploader__input-wrapper {
      width: 100%;
    }
    ::v-deep .van-uploader__wrapper--disabled {
      opacity: 1 !important;
    }
    .passportTitle {
      @include fontCommon;
      margin: 0 0 10px 10px;
    }
    .preview-container1 {
      position: absolute;
      left: 0;
      width: 50%;
      height: 11rem;
      z-index: 11;
    }
    .preview-container2 {
      position: absolute;
      right: 0;
      width: 50%;
      height: 11rem;
      z-index: 11;
    }
    .passportImgBox {
      width: 50%;
      display: inline-block;
      overflow: hidden;
      margin: 5% auto;
      text-align: center;
      .logoIcon {
        width: 8rem;
        height: 8rem;
        position: relative;
        object-fit: contain;
        background: transparent;
        .ImgIcon {
          width: 8rem;
          height: 8rem;
          position: relative;
          object-fit: contain;
          background: transparent;
        }
        ::v-deep .van-image__img {
          width: 8rem;
          height: 8rem;
          position: relative;
          object-fit: contain;
          background: transparent;
        }
        ::v-deep .van-image__error {
          width: 8rem;
          height: 8rem;
          position: relative;
          object-fit: contain;
          background: transparent;
        }
      }
    }
  }
  .inputBox {
    padding: 0.8rem 0.8rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    border-bottom: 0.1rem solid #eff0f5;
    .inputTitle {
      @include fontCommon;
    }
    .inputInfo {
      background: none;
      outline: none;
      border: none;
      flex: 1;
      text-align: right;
      @include fontCommon;
      &::placeholder {
        font-size: 12px;
        font-family: Helvetica;
        font-weight: 400;
        color: #cacaca;
        text-align: right;
      }
    }
  }
}
.footerBox {
  position: relative;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  .sub {
    width: 80%;
    padding: 0.4rem 0;
    line-height: 2;
    border-radius: 3rem;
    background: linear-gradient(left, #71d283, #01aaa3);
    text-align: center;
    font-size: 1rem;
    margin: 0 auto;
    color: #ffffff;
    font-weight: bold;
  }
}
</style>
